import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { ModalContext } from 'App';
import TaxCreditModal from '../modals/TaxCreditModal';

function TaxCreditList({ data, businessId }) {

  const setModal = useContext(ModalContext);

  const handleUpdateTaxCredit = info => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <TaxCreditModal taxCreditData={info} type="EDIT" businessId={businessId} />,
      title: 'Update Tax Credit',
      modalSize: 'modal-md',
    });
  };

  return (
    <div className="p-3">
      <table className="transaction-table table table-bordered table-sm">
        <thead>
          <tr>
            <th>Tax Credit Number / E-OR Number</th>
            <th className="text-center">Date</th>
            <th className="text-center">Amount</th>
            <th className="text-center">Balance</th>
            <th className="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => {
            return (
              <tr key={item.id}>
                <td>
                  <span className={`${get(item, 'attributes.amount') < 0 ? 'text-danger' : ''}`}>
                    {get(item, 'attributes.tc_number') || ''} {' '} {' '}
                    {get(item, 'attributes.e_or_no') || ''}
                  </span>
                </td>
                <td className="text-center">
                  <span className={`${get(item, 'attributes.amount') < 0 ? 'text-danger' : ''}`}> {get(item, 'attributes.date_human') || '-'} </span>
                </td>
                <td className="text-center">
                  <span className={`${get(item, 'attributes.amount') < 0 ? 'text-danger' : ''}`}> {get(item, 'attributes.amount_human') || '0.00'} </span>
                </td>
                <td className="text-right">
                  <span className={`${get(item, 'attributes.amount') < 0 ? 'text-danger' : ''}`}> {get(item, 'attributes.balance_human') || '-'} </span>
                </td>
                {/* {(Acl(permissions, ['UPDATE BPLS BILLING']) && get(applicationInfo, 'attributes.status') === 'COMPUTED') && ( */}
                {(index + 1 === data.length && get(item, 'attributes.amount') > 0) && (
                  <td className="text-center">
                    <div className="d-flex justify-content-center align-items-center">
                      <button
                        onClick={handleUpdateTaxCredit(item)}
                        type="button"
                        className="btn-blank btn-sm"
                      >
                        <i className="far fa-edit icon-edit" />
                      </button>
                    </div>
                  </td>
                )}
                {/* )} */}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

TaxCreditList.defaultProps = {
  data: {},
  businessId: '',
}

TaxCreditList.propTypes = {
  data: PropTypes.instanceOf(Array),
  businessId: PropTypes.string,
};

export default TaxCreditList;
